import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { CalendarMonthRounded } from '@mui/icons-material'
import { InputField } from '../../../components/InputField'
import { ENDPOINT, Routes } from '../../../constants'
import { useAuth } from '../../../contexts/AuthContext'
import { FeaturedProps } from '../../../types/featured'
import { FetchApi } from '../../../api/fetch'

function ManageReward() {
   const { state } = useLocation<FeaturedProps>()
   const { push } = useHistory()

   const [featured, setFeatured] = useState<FeaturedProps | any>(state)
   const {  setIsLoadingOverlayDisplay } = useAuth()

   const handleChange = (e: any) => {
      const { target } = e;

      setFeatured({ ...featured, [target.name]: target.value })

      console.log(featured, target.name, target.value)
   }

   const saveFeatured = async (e: any) => {
      e.preventDefault()

      setIsLoadingOverlayDisplay(true)
      const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

      if (state?.id !== undefined) {
         try {
            let response: any = await FetchApi( {
               endpoint:`${ENDPOINT.BASE_ENDPOINT}/featured_project/${state?.id}`,
               method: "PATCH",
               JWT:userJWT,
               body:  ({ ...featured, thumbnailUrl: '', position: 1 })
            })

            if (response.success) push(Routes.FEATURED_COLLECTION)
        
         } catch (error) {
            // console.log('something went wrong');
         }
      } else {
         try {
            await FetchApi({
               endpoint: `${ENDPOINT.BASE_ENDPOINT}/featured_project`,
               method: "POST",
               JWT: userJWT,
               body:  ({ ...featured, thumbnailUrl: "", position: 1 })
            })

           push(Routes.FEATURED_COLLECTION)

         } catch (error) {
            console.log('something went wrong', error);

         }
      }

      setIsLoadingOverlayDisplay(false)
   }

   return (
      <div className='w-11/12 m-auto my-10'>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-3xl text-left">
               {state?.id ? 'Edit' : 'Create New'} Featured Project
            </h1>
         </div>
         <form onSubmit={saveFeatured}>
            <div className="mb-8">
               <div >
                  <div>
                     <InputField
                        type="text"
                        // value={searchText}
                        // onChange={handleSearch}
                        label='NFT Token Address'
                        className="w-full  mb-1 mx-0 border-gray-80 "
                        placeholder="Search for NFT Token Address "
                     />
                  </div>
                  <div className='grid grid-cols-2 gap-4'>
                     <div className="mb-4">
                        <label className="inline-block text-sm font-base text-gray-40 mb-2 w-5/6 mr-0">
                           Type
                        </label>
                        <select name="collectionId" className="w-full h-12 bg-transparent text-gray-40 border border-kyzzen-secondary border-box py-2 px-2 rounded-lg"  >
                           <option value="0">Select type</option>
                        </select>
                     </div>
                     <InputField
                        label="No. of Tickets"
                        name='name'
                        defaultValue={state?.name}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div>
                     <label className="inline-block text-sm font-base text-gray-40 mb-2 w-5/6 mr-0">
                        Date Range
                     </label>
                     <div className='grid grid-cols-2 gap-4'>
                        <div className='flex items-center gap-2'>
                           <label className="inline-block text-sm font-base text-gray-40 mb-2 font-extralight mr-0">
                              Start
                           </label>
                           <InputField
                              type='datetime-local'
                           />
                           <span className='w-fit bg-accent-green p-1 pb-1.5 rounded-xl mb-4'>
                              <CalendarMonthRounded className='text-kyzzen-primary w-8 h-8' />
                           </span>
                        </div>
                        <div className='flex items-center gap-2'>
                           <label className="inline-block text-sm font-base text-gray-40 font-extralight mb-2  mr-0">
                              End
                           </label>
                           <InputField
                              type='datetime-local'
                           />
                           <span className='w-fit bg-accent-green p-1 pb-1.5 rounded-xl mb-4'>
                              <CalendarMonthRounded className='text-kyzzen-primary w-8 h-8' />
                           </span>
                        </div>
                     </div>
                  </div>

               </div>
            </div>
            <div className='grid grid-cols-2 gap-4'>
               <button type="submit" className="btn w-full border-gradient ">Preview</button>
               <button type="submit" className="btn w-full bg-gradient text-kyzzen-primary">Save</button>
            </div>
         </form>
      </div>
   )
}

export default ManageReward